import { InjectionToken, FactoryProvider } from '@angular/core';
import { IStorage } from './i-storage.model';

export const LOCAL_STORAGE = new InjectionToken<IStorage>('localStorage');

const localStorageProvider: FactoryProvider = {
    provide: LOCAL_STORAGE,
    useFactory: () => localStorage
};

export const LOCAL_STORAGE_PROVIDERS = [
    localStorageProvider
];
